import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { isNullOrUndefined } from '../../../app/core/utils';
import { AuthService } from '../../core/auth.service';
import { CommonService } from '../../core/common.service';
import { nullSafe } from '../../utils';
import { ConfigurationApi} from 'src/app/core/api.gen';

@Component({
    selector: 'eos-authorised-layout',
    templateUrl: './authorised-layout.component.html'
})
export class AuthorisedLayoutComponent implements OnInit, OnDestroy {
    static readonly ROUTE_DATA_BREADCRUMB = 'breadcrumb';
  static readonly ROUTE_DATA_BREADCRUMB_URL = 'breadcrumbUrl';
    isIframe = false;
    menuList: any[] = [];
    visaTypes: any;
    exitTypes: any;

    isDelegateSet = false;
    delegateSubscription: Subscription;
    visaTypeSubscription: Subscription;
    exitTypeSubscription: Subscription;
    isPendingStartdates = false;
    isPendingComment = false;
    isPendingImmAutoVisaRequestProfiles = false;
    returnLink: any;
    private pendingProfilesSubscription;
    private pendingCommentProfilesSubscription;
    private pendingImmAutoVisaRequestProfilesSubscription;
    uploadYorDocurl: string;
    uploadDepDocurl: string;
    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private authService: AuthService,
        private commonService: CommonService,
        private configurationService: ConfigurationApi,
    ) { }

    shouldDarkBg(): boolean {
        return ['/home', '/immigration', '/exit'].indexOf(this.router.url) > -1;

    }

    ngOnInit(): void {
      this.isIframe = window !== window.parent && !window.opener;
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() =>
                this.menuList = this.createBreadcrumbs(this.activatedRoute.root, '', [{ label: 'Home', url: '/home' }]
              ));

      if (this.authService.isAuthenticated) {
            if (isNullOrUndefined(this.commonService.visaTypes$)) {
                this.commonService.visaTypes$ = this.commonService.prepareLookupObservable(38);
            }

            if (isNullOrUndefined(this.commonService.exitTypes$) ) {
                this.commonService.exitTypes$ = this.commonService.prepareLookupObservable(131);
            }
            
            this.exitTypeSubscription = this.commonService.exitTypes$.subscribe(res => {
                    this.exitTypes = res;
            });

            this.visaTypeSubscription = this.commonService.visaTypes$.subscribe(res => {
                this.visaTypes = res;
            });

           

            this.commonService.updateDelegateStatus(nullSafe(() => this.authService.ActiveUser.userId, null));

            this.delegateSubscription = this.commonService.delegateStatus$.subscribe(delagateFlag => {
                // if (delagateFlag) {
                //   this.toaster.show('Actions are currently being delegated. Go to settings to undo delegation',
                //     { classname: 'alert-delegate', autohide: false });
                this.isDelegateSet = delagateFlag;			// }		
            });
         
          this.pendingProfilesSubscription = this.commonService.pendingStartdateProfiles$.subscribe(pendingFlag => {
                this.isPendingStartdates = pendingFlag;
          });

          this.pendingCommentProfilesSubscription = this.commonService.pendingCommentProfiles$.subscribe(pendingFlag => {
            this.isPendingComment = pendingFlag;
          });
        this.pendingImmAutoVisaRequestProfilesSubscription = this.commonService.pendingImmAutoVisaRequestProfiles$.subscribe(pendingFlag => {
          this.isPendingImmAutoVisaRequestProfiles = pendingFlag;
      });
          this.getVideoLinks();
        }
    }

    private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: any[] = []): any[] {
        const children: ActivatedRoute[] = route.children;

        if (children.length === 0) {
          breadcrumbs[breadcrumbs.length - 1].isActive = true;
            return breadcrumbs;
      }

        for (const child of children) {
            const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
            if (routeURL !== '') {
                url += `/${routeURL}`;
            }

            let label: string = child.snapshot.data[AuthorisedLayoutComponent.ROUTE_DATA_BREADCRUMB];
            let breadcrumbUrl: string = child.snapshot.data[AuthorisedLayoutComponent.ROUTE_DATA_BREADCRUMB_URL] || url;

            if (!isNullOrUndefined(breadcrumbUrl) && breadcrumbUrl.includes('::')) {
              const matches: string[] = breadcrumbUrl.match(/::\w+/g) ?? [];
              matches.forEach(token => {
                const key = token.replace('::', '');
                const value = child.snapshot.params[key];
                breadcrumbUrl = breadcrumbUrl.replace(token, value || '');
              });
            }
            if (!isNullOrUndefined(label) && label.includes('::')) {
                // the 2colon is given to take visa and country type for immigration URL and put it param.data
                const labelsArr = label.split(',');
                label = '';
                labelsArr.forEach(l => {
                    const key = l.replace('::', '').trim();
                    if (key === 'type') {
                        const v = this.visaTypes.find(item => item.value === child.snapshot.params[key]);
                        label = child.snapshot.params['country'] + '- ' + v.displayText;
                    } else if(key == 'exitType') {
                        const v = this.exitTypes.find(item => item.value === child.snapshot.params[key]);
                        label = v.displayText;
                    } else {
                        label += child.snapshot.params[key] + ' ';
                    }

                });
            }
            if (!isNullOrUndefined(label) && breadcrumbs.filter(x => x.label === label).length <= 0) {
              breadcrumbs.push({ label, url: breadcrumbUrl });
            }

            return this.createBreadcrumbs(child, url, breadcrumbs);
        }
  }
  isProfileUpdate(): boolean {
    return this.commonService.isProfileUpdate();
  }
  openVideoTab(url: string) {
    window.open(url);
  }

  getVideoLinks() {
    this.configurationService
      .getAppConfigValue("UserProfileVideoUrl")
      .subscribe(
        (resp) => {
          let jsonObject = JSON.parse(resp)
          this.uploadYorDocurl = jsonObject.uploadYourDoc;
          this.uploadDepDocurl = jsonObject.uploadYourDepDetails;
        }
      );
  }
    closeDelegateWarning() {
        this.isDelegateSet = false;
    }
    ngOnDestroy(): void {
        if (this.pendingProfilesSubscription)
        this.pendingProfilesSubscription.unsubscribe();
      if (this.pendingCommentProfilesSubscription)
        this.pendingCommentProfilesSubscription.unsubscribe();
      if (this.pendingImmAutoVisaRequestProfilesSubscription)
        this.pendingImmAutoVisaRequestProfilesSubscription.unsubscribe();
        if (this.delegateSubscription)
            this.delegateSubscription.unsubscribe();
        if (this.visaTypeSubscription)
            this.visaTypeSubscription.unsubscribe();
        if (this.exitTypeSubscription)
            this.exitTypeSubscription.unsubscribe();

    }
}
